import { GatewayUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/outputs/gateway-user.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { UserListRoleCell } from '@app/feature/user/user-list/user-list-roles.cell';
import { UserListRolesHeader } from '@app/feature/user/user-list/user-list-roles.header';

export const CustomerUserListRolesColumn: IdentifiedColumnDef<
  GatewayUserModel,
  GatewayUserModel['roles']
> = {
  enableSorting: false,
  header: UserListRolesHeader,
  cell: UserListRoleCell,
};
